export default __webpack_public_path__ + "static/media/Me-O Persian Kitten Cat Food Dry.57afff16.png";